import React, { MouseEventHandler } from 'react';
import { extractStatusText, getActiveUntil } from 'flow/utils';
import PbxListItem from './PbxListItem';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';

import {
    selectContactFixedNumber,
    selectContactName,
    selectExtensionActiveProfile,
} from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { RowMarking } from './BaseListItem';

interface Props {
    itemKey: ExtensionKey;
    onClick: MouseEventHandler;
    marking?: RowMarking;
}

const ListItemAICoworker = ({ itemKey, onClick, marking }: Props) => {
    const { i18next } = useAppContext();
    const activeProfile = useAppSelector((state) =>
        selectExtensionActiveProfile(state, itemKey),
    );

    const name = useAppSelector((state) => selectContactName(state, itemKey));
    const phoneNumber = useAppSelector((state) =>
        selectContactFixedNumber(state, itemKey),
    );

    return (
        <PbxListItem
            onClick={onClick}
            marking={marking}
            type="aicoworker"
            title={name}
            description={
                activeProfile &&
                `${extractStatusText(
                    activeProfile,
                    i18next,
                )} ${getActiveUntil(activeProfile, i18next)}`
            }
            phoneNumber={phoneNumber}
        />
    );
};

export default React.memo(ListItemAICoworker);
